/**
 *
 * AuthenticatorHeader Component
 *
 */

import { stylize } from "@envestnet/envreact-component-library";
import { faUserCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import React from "react";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
}

export interface AuthenticatorHeaderProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;

  userId: string;

  authenticatorName: string;
}

const defaultProps: DefaultProps = {};

type Props = InjectedProps & AuthenticatorHeaderProps;

const AuthenticatorHeader = (props: Props) => {
  const {
    classes,
    style,
    className,
    formatMessage,
    innerRef,
    authenticatorName,
    userId,
  } = props;

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div className={classnames(classes.header, "header-font-family")}>
        {formatMessage(messages.header, { authenticatorName })}
      </div>
      <div className={classes.userIdSection}>
        <FontAwesomeIcon icon={faUserCircle} />
        <span className={classnames(classes.userId, "header-text-font-family")}>
          {userId}
        </span>
      </div>
    </div>
  );
};

AuthenticatorHeader.defaultProps = defaultProps;

export default withIntl(
  stylize<Props, DefaultProps>(styles)(AuthenticatorHeader)
);
